import { type ReactNode, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { useSegment } from '@/connect-context/tracking/useSegment'
import useUser from '@/hooks/useUser'

const OauthContext = ({ children }: { children: ReactNode }) => {
  const user = useUser()
  const segment = useSegment()

  useEffect(() => {
    if (!segment || !user) return
    console.info({ segment, user }, 'segment-identify')

    segment.identify(user.uid, {
      name: `${user?.first ?? ''} ${user?.last ?? ''}`,
      email: user.email,
      createdAt: user.created,
      lastName: user.last,
      firstName: user.first,
      company: {
        name: user.company,
      },
      version: import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA,
    })
  }, [segment, user])

  useEffect(() => {
    if (user) {
      Sentry.setUser({ email: user.email, id: user.uid })
    }
  }, [user])

  return children
}

export default OauthContext
